import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_7ff858f6 from 'nuxt_plugin_plugin_7ff858f6' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_nuxtcookiecontrol_22d5f644 from 'nuxt_plugin_nuxtcookiecontrol_22d5f644' // Source: ./nuxt-cookie-control.js (mode: 'all')
import nuxt_plugin_templatesplugin4345c186_268d73f0 from 'nuxt_plugin_templatesplugin4345c186_268d73f0' // Source: ./templates.plugin.4345c186.js (mode: 'client')
import nuxt_plugin_vuescrollto_426c8906 from 'nuxt_plugin_vuescrollto_426c8906' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_moment_2ed46e0c from 'nuxt_plugin_moment_2ed46e0c' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_workbox_66c32728 from 'nuxt_plugin_workbox_66c32728' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_4cb6c63b from 'nuxt_plugin_metaplugin_4cb6c63b' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_515e6baf from 'nuxt_plugin_iconplugin_515e6baf' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_googleanalytics_632e339a from 'nuxt_plugin_googleanalytics_632e339a' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_gtm_d653423c from 'nuxt_plugin_gtm_d653423c' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_axios_19cfc50c from 'nuxt_plugin_axios_19cfc50c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_nuxtapollomodule_18e310ac from 'nuxt_plugin_nuxtapollomodule_18e310ac' // Source: ./nuxt-apollo-module.js (mode: 'all')
import nuxt_plugin_toast_33ffdc8a from 'nuxt_plugin_toast_33ffdc8a' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_pluginutils_e8a03aa2 from 'nuxt_plugin_pluginutils_e8a03aa2' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_1542803a from 'nuxt_plugin_pluginrouting_1542803a' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_2b623516 from 'nuxt_plugin_pluginmain_2b623516' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_ded46698 from 'nuxt_plugin_cookieuniversalnuxt_ded46698' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_filters_0a501042 from 'nuxt_plugin_filters_0a501042' // Source: ../plugins/filters (mode: 'all')
import nuxt_plugin_bugsnag_4aea807c from 'nuxt_plugin_bugsnag_4aea807c' // Source: ../plugins/bugsnag (mode: 'all')
import nuxt_plugin_directives_f60b4746 from 'nuxt_plugin_directives_f60b4746' // Source: ../plugins/directives (mode: 'all')
import nuxt_plugin_formulate_582614de from 'nuxt_plugin_formulate_582614de' // Source: ../plugins/formulate (mode: 'all')
import nuxt_plugin_fontawesome_5e0b9dfb from 'nuxt_plugin_fontawesome_5e0b9dfb' // Source: ../plugins/fontawesome (mode: 'all')
import nuxt_plugin_swiper_1f8a1751 from 'nuxt_plugin_swiper_1f8a1751' // Source: ../plugins/swiper (mode: 'all')
import nuxt_plugin_vuecharts_683f0656 from 'nuxt_plugin_vuecharts_683f0656' // Source: ../plugins/vue-charts (mode: 'all')
import nuxt_plugin_VShowSlide_e4cf7952 from 'nuxt_plugin_VShowSlide_e4cf7952' // Source: ../plugins/VShowSlide (mode: 'all')
import nuxt_plugin_download_806e35be from 'nuxt_plugin_download_806e35be' // Source: ../plugins/download (mode: 'all')
import nuxt_plugin_minDate_7ca1fd67 from 'nuxt_plugin_minDate_7ca1fd67' // Source: ../plugins/minDate (mode: 'all')
import nuxt_plugin_masonry_6f556a8c from 'nuxt_plugin_masonry_6f556a8c' // Source: ../plugins/masonry (mode: 'client')
import nuxt_plugin_vcalendar_16d9fd0e from 'nuxt_plugin_vcalendar_16d9fd0e' // Source: ../plugins/v-calendar (mode: 'client')
import nuxt_plugin_vueellipseprogress_a0694888 from 'nuxt_plugin_vueellipseprogress_a0694888' // Source: ../plugins/vue-ellipse-progress (mode: 'client')
import nuxt_plugin_turnstile_5994444c from 'nuxt_plugin_turnstile_5994444c' // Source: ../plugins/turnstile.js (mode: 'client')
import nuxt_plugin_plugin_b58c4d70 from 'nuxt_plugin_plugin_b58c4d70' // Source: ./auth/plugin.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    return this.$root.$options.$nuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule
const baseStoreOptions = { preserveState: process.client }

function registerModule (path, rawModule, options = {}) {
  return originalRegisterModule.call(this, path, rawModule, { ...baseStoreOptions, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"NVPA","titleTemplate":(t) => {
      return t + (t === 'NVPA' ? '' : ' – NVPA');
    },"htmlAttrs":{"lang":"nl"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"description","hid":"description","content":""},{"name":"apple-mobile-web-app-title","hid":"apple-mobile-web-app-title","content":"NVPA"},{"name":"og:title","hid":"og:title","content":"NVPA"},{"name":"og:description","hid":"og:description","content":""},{"name":"og:site_name","hid":"og:site_name","content":"NVPA"}],"link":[{"hid":"gf-prefetch","rel":"dns-prefetch","href":"https:\u002F\u002Ffonts.gstatic.com\u002F"},{"hid":"gf-preconnect","rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com\u002F","crossorigin":""},{"hid":"gf-preload","rel":"preload","as":"style","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Nunito+Sans:wght@400;500;600;700;800;900"}],"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function (w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-P4V7VPX')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"},{"hid":"gf-script","innerHTML":"(function(){var l=document.createElement('link');l.rel=\"stylesheet\";l.href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Nunito+Sans:wght@400;500;600;700;800;900\";document.querySelector(\"head\").appendChild(l);})();"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-P4V7VPX&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"},{"hid":"gf-noscript","innerHTML":"\u003Clink rel=\"stylesheet\" href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Nunito+Sans:wght@400;500;600;700;800;900\"\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"],"gf-script":["innerHTML"],"gf-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_7ff858f6 === 'function') {
    await nuxt_plugin_plugin_7ff858f6(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtcookiecontrol_22d5f644 === 'function') {
    await nuxt_plugin_nuxtcookiecontrol_22d5f644(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin4345c186_268d73f0 === 'function') {
    await nuxt_plugin_templatesplugin4345c186_268d73f0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_426c8906 === 'function') {
    await nuxt_plugin_vuescrollto_426c8906(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_2ed46e0c === 'function') {
    await nuxt_plugin_moment_2ed46e0c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_66c32728 === 'function') {
    await nuxt_plugin_workbox_66c32728(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_4cb6c63b === 'function') {
    await nuxt_plugin_metaplugin_4cb6c63b(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_515e6baf === 'function') {
    await nuxt_plugin_iconplugin_515e6baf(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_632e339a === 'function') {
    await nuxt_plugin_googleanalytics_632e339a(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_d653423c === 'function') {
    await nuxt_plugin_gtm_d653423c(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_19cfc50c === 'function') {
    await nuxt_plugin_axios_19cfc50c(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtapollomodule_18e310ac === 'function') {
    await nuxt_plugin_nuxtapollomodule_18e310ac(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_33ffdc8a === 'function') {
    await nuxt_plugin_toast_33ffdc8a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_e8a03aa2 === 'function') {
    await nuxt_plugin_pluginutils_e8a03aa2(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_1542803a === 'function') {
    await nuxt_plugin_pluginrouting_1542803a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_2b623516 === 'function') {
    await nuxt_plugin_pluginmain_2b623516(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_ded46698 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_ded46698(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_0a501042 === 'function') {
    await nuxt_plugin_filters_0a501042(app.context, inject)
  }

  if (typeof nuxt_plugin_bugsnag_4aea807c === 'function') {
    await nuxt_plugin_bugsnag_4aea807c(app.context, inject)
  }

  if (typeof nuxt_plugin_directives_f60b4746 === 'function') {
    await nuxt_plugin_directives_f60b4746(app.context, inject)
  }

  if (typeof nuxt_plugin_formulate_582614de === 'function') {
    await nuxt_plugin_formulate_582614de(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_5e0b9dfb === 'function') {
    await nuxt_plugin_fontawesome_5e0b9dfb(app.context, inject)
  }

  if (typeof nuxt_plugin_swiper_1f8a1751 === 'function') {
    await nuxt_plugin_swiper_1f8a1751(app.context, inject)
  }

  if (typeof nuxt_plugin_vuecharts_683f0656 === 'function') {
    await nuxt_plugin_vuecharts_683f0656(app.context, inject)
  }

  if (typeof nuxt_plugin_VShowSlide_e4cf7952 === 'function') {
    await nuxt_plugin_VShowSlide_e4cf7952(app.context, inject)
  }

  if (typeof nuxt_plugin_download_806e35be === 'function') {
    await nuxt_plugin_download_806e35be(app.context, inject)
  }

  if (typeof nuxt_plugin_minDate_7ca1fd67 === 'function') {
    await nuxt_plugin_minDate_7ca1fd67(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_masonry_6f556a8c === 'function') {
    await nuxt_plugin_masonry_6f556a8c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vcalendar_16d9fd0e === 'function') {
    await nuxt_plugin_vcalendar_16d9fd0e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueellipseprogress_a0694888 === 'function') {
    await nuxt_plugin_vueellipseprogress_a0694888(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_turnstile_5994444c === 'function') {
    await nuxt_plugin_turnstile_5994444c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_b58c4d70 === 'function') {
    await nuxt_plugin_plugin_b58c4d70(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
